import { MfeContainer, MfeModule } from '../../features/mfe/types'
import { ensureContainerIsActive } from './container'

const loadModule = async <T>(containerName: MfeContainer, moduleName: MfeModule): Promise<T> => {
  const container = await ensureContainerIsActive(containerName)

  const moduleFactory = await container.get<T>(`./${moduleName}`)
  const module = await moduleFactory()
  return module.default
}

export default loadModule
